<template>
  <div class="container">
    <b-modal
        :model-value="modCrearMenu"
        :no-close-on-backdrop="true"
        hide-footer
                centered
        :title="labels.title"
        header-class="reset-modal-header"
        title-class="reset-modal-title"
        body-class="reset-modal-body"
        class="reset-password-dialog create-menu-dialog"
     @hide="cierraModal">
        <div class="uniform-modal-body">
            <div class="password-policy-box mb-4">
                <div class="password-policy-title">{{ labels.infoTitle }}</div>
                <div class="password-policy-subtitle">{{ labels.infoText }}</div>
            </div>

            <!-- Campo: Nombre -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.name }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="nombre" 
                        type="text" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="Nombre del menú"
                    />
                </b-col>
            </b-row>

            <!-- Campo: Ruta -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.ruta }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="ruta" 
                        type="text" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="/ruta-del-menu"
                    />
                </b-col>
            </b-row>

            <!-- Campo: Icono -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.icono }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-select
                        v-model="icono"
                        :options="iconSelectOptions"
                        class="form-input"
                    />
                </b-col>
            </b-row>

            <!-- Campo: Orden -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.orden }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="orden" 
                        type="number" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="Número de orden"
                    />
                </b-col>
            </b-row>

            <!-- Campo: Roles -->
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.roles }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-select
                        v-model="rolSelected"
                        :options="roleSelectOptions"
                        class="form-input"
                        multiple
                    />
                </b-col>
            </b-row>

            <!-- Botones de acción -->
            <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                <b-button class="mr-2 reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
                <b-button class="reset-btn-primary" @click="guardarMenu">{{ labels.save }}</b-button>
            </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import Menu from '../../../services/Menu'; 
import Roles from '../../../services/Roles'; 
import { getMenuIconNames } from '../../../utils/menuIconCatalog';

export default {
    name: "CrearMenu",
    props: ['modCrearMenu'],
    data: () => ({
        nombre: "",
        ruta: "",
        icono: "",
        orden: "",
        roles: [],
        rolSelected: [],
        iconOptions: []
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Crear menú",
                    save: "Guardar",
                    close: "Cerrar",
                    name: "Nombre",
                    ruta: "Ruta",
                    icono: "Icono",
                    roles: "Roles",
                    orden: "Orden",
                    infoTitle: "Datos del menú",
                    infoText: "Completa la información y guarda el nuevo menú."
                }
            } else {
                return {
                    title: "Create menu",
                    save: "Save",
                    close: "Close",
                    name: "Name",
                    ruta: "Route",
                    icono: "Icon",
                    roles: "Role",
                    orden: "Order",
                    infoTitle: "Menu information",
                    infoText: "Complete the information and save the new menu."
                }
            }
        },
        iconSelectOptions() {
            const base = this.$store.state._language == "es-ES"
                ? [{ value: "", text: "Seleccione un icono" }]
                : [{ value: "", text: "Select an icon" }];
            const items = this.iconOptions.map((iconName) => ({
                value: iconName,
                text: iconName
            }));
            return [...base, ...items];
        },
        roleSelectOptions() {
            const base = this.$store.state._language == "es-ES"
                ? [{ value: "", text: "Seleccione roles (múltiple)" }]
                : [{ value: "", text: "Select roles (multiple)" }];
            const items = this.roles.map((rol) => ({
                value: rol.id,
                text: rol.nombre
            }));
            return [...base, ...items];
        }
    },
    methods: {
        cierraModal() {
            this.$emit('closeModal', false)
            this.resetForm()
        },
        resetForm() {
            this.nombre = ""
            this.ruta = ""
            this.icono = ""
            this.orden = ""
            this.rolSelected = []
        },
        guardarMenu() {
            if (this.nombre == "") {
                this.$toast.error("Diligenciar el campo Nombre")
                return
            }
            if (this.ruta == "") {
                this.$toast.error("Diligenciar el campo Ruta")
                return
            }
            if (this.icono == "") {
                this.$toast.error("Diligenciar el campo Icono")
                return
            }
            if (this.orden == "") {
                this.$toast.error("Diligenciar el campo Orden")
                return
            }
            if (this.rolSelected.length == 0) {
                this.$toast.error("Seleccionar mínimo un Rol")
                return
            }

            const formu = {
                'nombre': this.nombre,
                'ruta': this.ruta,
                'icono': this.icono,
                'roles': this.rolSelected,
                'orden': this.orden,
                'idUser': this.$store.state.userId
            }

            Menu.createMenu(formu)
                .then((res) => {
                    if (res.status == 200) {
                        this.$toast.success(res.data.message)
                        this.$emit('created')
                        this.cierraModal()
                    } else if (res.status == 204) {
                        this.$toast.error("El menú ingresado ya existe")
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error("Error al crear el menú")
                })
        }
    },
    mounted() {
        this.iconOptions = getMenuIconNames();
        Roles.getAllRoles()
            .then((res) => {
                this.roles = res.data.roles
            })
            .catch((err) => {
                console.log(err)
            })
    }
}
</script>